<template>
  <GallerySection />
</template>

<script>
import GallerySection from '../components/sections/GallerySection.vue'

export default {
  name: 'GalleryPage',
  components: {
    GallerySection
  }
}
</script>
